import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { CallRetentionPolicyOption } from '../models/call-retention-policy-option';
import { callRetentionPolicyOptionActions } from '../state/call-retention-policy-option.actions';
import { callRetentionPolicyOptionSelectors } from '../state/call-retention-policy-option.reducer';

@Directive({
    selector: '[ndtCallRetentionPolicySelect]',
    standalone: false
})
export class CallRetentionPolicySelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<CallRetentionPolicyOption>,
      private statusService: NgrxEagerSelectService<AppState, CallRetentionPolicyOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            callRetentionPolicyOptionActions,
            callRetentionPolicyOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('callRetentionPolicy', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
